import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.generated.js';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(container);
root.render(React.createElement(React.StrictMode, null, React.createElement(App)));

reportWebVitals();
